export default "__VITE_ASSET__11861bb2__"